import axios from 'axios';
import { customAlert } from '@/utils/sweetalert';
import { API_BASE_URL, getTenant, LANGUAGE } from '../config/constant';
import router from '@/router/index';
import store from '@/state/store';
import { PREFIX } from './constants';
import i18n from '@/i18n';

const API_TIMEOUT = 20000;

export const apiHeader = () => {
  return {
    Authorization: store.getters['authUser/userToken'] ? `Bearer ${store.getters['authUser/userToken']}` : null,
    Accept: 'application/json',
    ContentType: 'application/json',
    'Accept-Language': LANGUAGE.language || 'en',
  };
};

export const apiResponseCatch = (error) => {
  const status = error?.response?.status ?? 0;
  const isLoginRequest = error?.config?.url?.includes('/auth/login');
  const isSilent = error?.config?.silentError;

  if (status == 401 && !isLoginRequest) {
    customAlert(error?.response?.data?.message ?? i18n.global.t('main.apiError'), 'error');
    store.dispatch('authUser/setUserToken', null);
    store.dispatch('authUser/setUserData', null);

    const splited_pathname = window.location.pathname.split('/');
    router.push(`/${splited_pathname[1] || PREFIX.SUPER_ADMIN}`);
  } else if (status == 422) {
    window.scrollTo(0, 0);
  } else if (!isLoginRequest && !isSilent && status != 422) {
    customAlert(error?.response?.data?.message ?? i18n.global.t('main.apiError'), 'error');
  }

  return Promise.reject(error);
};

export default () => {
  const apiClient = axios.create({
    baseURL: API_BASE_URL + getTenant(),
    headers: apiHeader(),
    timeout: API_TIMEOUT,
  });
  apiClient.interceptors.response.use((response) => {
    return response;
  }, apiResponseCatch);
  return apiClient;
};
